//ONBOARDING
export const EMAIL_UNVERIFIED = "email_unverified";
export const ACCOUNT_CREATE_TYPE = "account_create_type";
export const REASON = "reason";
export const BUS_TYPE = "bus_type";
export const LOGIN_METHOD = "login_method";
export const FAILURE_REASON = "failure_reason";
export const EMAIL = "email";
export const USER_ID = "user_id";
export const DAILY_TRANSACTION_LIMIT = "daily_transaction_limit";
export const SINGLE_TRANSACTION_LIMIT = "single_transaction_limit";
export const STATUS = "status";
export const UNVERIFIED_ADDRESS = "unverified_address";
//PAYMENTS
export const TRANSACTION_TYPE = "transaction_type";
export const DESTINATION = "destination";
export const DESTINATION_BANK = "destination_bank";
export const DESTINATION_ACCOUNT = "destination_account";
export const SENDING_ACCOUNT = "sending_account";
export const AMOUNT = "amount";
export const BUSINESS_USER_TYPE = "business_user_type";
export const VALUE = "value";
export const TRANSACTION_ID = "transaction_id";
export const CURRENCY = "currency";
export const ACCOUNT_USED = "account_used";
export const TOTAL_TRANSFERS_SENT = "total_transfers_sent";

//SCHEDULE PAYMENTS
export const SCHEDULE_START_DATE = "schedule_date";
export const SCHEDULE_END_DATE = "schedule_time";
export const SCHEDULE_FREQUENCY = "schedule_frequency";
export const SCHEDULE_EXECUTION = "schedule_execution";
// AIRTIME RECHARGE
export const AIRTIME_OPERATOR = "airtime_operator";
//BILL PAYMENT
export const BILL_TYPE = "bill_type";
export const BILL_PAYMENT_OPERATOR = "bill_payment_operator";
//NEW TO BANK
export const CUSTOMER_TYPE = "customer_type";
export const SIGN_UP_TYPE = "sign_up_type";
export const ID_TYPE = "id_type";
export const BUSINESS_ACCOUNT_TYPE = "business_account_type";
export const PLATFORM = "platform";
// CARDS
export const CARD_PROVIDER = "card_provider";
export const CARD_STATUS = "card_status";
export const FULFILLMENT_TYPE = "fulfillment_type";
// BUSINESS REG
export const REGISTRATION_TYPE = "regsitration_type";
export const BUSINESS_TYPE_REGISTRATION = "business_type_registration";
// SUB ACCOUNT
export const SUB_ACCOUNT_NAME = "sub_account_name";
// PAYROLL
export const EMPLOYEES_IN_SCHEDULE = "employees_in_schedule";
export const PAYROLL_FREQUENCY = "payroll_frequency";
export const PAYROLL_RUN_TYPE = "payroll_run_type";
export const EMPLOYEES_ADDED = "employees_added";
export const SETUP_STAGE = "setup_stage";
// POS
export const POS_TYPE = "pos_type";
export const TOTAL_POS_ORDERED = "total_pos_ordered";
export const DELIVERY_OPTION = "delivery_option";

// PERKS
export const PARTNER_NAME = "partner_name";
export const PARTNER_DETAILS_PERKS = "partner_details_perks";
